module.exports = __webpack_public_path__ + "img/advisory_select_type_bj03.829cb96c.png";